var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-tab-scroller",class:_vm.classes},[_c('div',{staticClass:"mdc-tab-scroller__scroll-area"},[_c('div',{staticClass:"mdc-tab-scroller__scroll-content"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }